import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { SystemSection } from './components/SystemSection';
import { IncludesSection } from './components/IncludesSection';
import { TransformSection } from './components/TransformSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    // Inject Meta Pixel script
    if (!document.getElementById('meta-pixel-script')) {
      const script = document.createElement('script');
      script.id = 'meta-pixel-script';
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1981397679255334');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1981397679255334&ev=PageView&noscript=1" />`;
      document.head.appendChild(noscript);
    }
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-terracotta/20" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StorySection data-id="element-2" />
      <SystemSection data-id="element-3" />
      <IncludesSection data-id="element-4" />
      <TransformSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <Footer data-id="element-7" />

      {/* Sticky Mobile CTA */}
      <AnimatePresence data-id="element-8">
        {showStickyCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-cream-dark shadow-[0_-4px_20px_rgba(0,0,0,0.1)] z-50 md:hidden" data-id="element-9">
            <a href="#pricing" className="flex items-center justify-center w-full px-6 py-3 text-white font-bold rounded-xl shadow-md active:scale-95 transition-transform bg-[#DF1189]" data-id="element-10">
              Descargar Plan — $6,39$
            </a>
          </motion.div>}
      </AnimatePresence>
    </div>;
}